module.exports = __webpack_public_path__ + "img/landscape-5.39743fb4.jpg";